import clsx from 'clsx';
import { Link } from 'react-router-dom';
import deusLogo from '@/assets/deuslogo.png';
import styles from './LeadGenLogo.module.css';

/**
 * The LeadGen lockup, as the sidebar draws it.
 *
 * WHY THIS IS NOT ITS OWN DRAWING ANY MORE. This component used to render a
 * hand-built SVG constellation -- twenty strokes and nine circles -- in orange
 * (#EA580C / #F97316) beside a wordmark whose second half was blue (#2563eb).
 * Three problems, in order of how much they showed:
 *
 *   1. It was a DIFFERENT MARK from the one the application uses. Sidebar.tsx
 *      renders assets/deuslogo.png; signing in therefore changed the logo.
 *   2. Two unrelated accent colours in one lockup, neither of them from the
 *      token system, which is otherwise near-monochrome.
 *   3. Twenty strokes rendered at 34px is not a mark, it is a smudge. Detail
 *      that cannot survive its own display size is detail that costs clarity
 *      and returns nothing.
 *
 * So it shows the real asset at the real proportions. The size variants exist
 * because this lockup appears at three scales across the auth screens.
 */
export interface LeadGenLogoProps {
  readonly size?: 'sm' | 'md' | 'lg';
  readonly to?: string;
  readonly className?: string;
}

export function LeadGenLogo({ size = 'md', to = '/', className }: LeadGenLogoProps) {
  const content = (
    <div className={clsx(styles.logoLink, styles[size], className)}>
      <div className={styles.logoIcon}>
        <img src={deusLogo} alt="" className={styles.logoImage} />
      </div>

      <div className={styles.logoText}>
        <span className={styles.lead}>Lead</span>
        <span className={styles.gen}>Gen</span>
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} style={{ textDecoration: 'none' }} aria-label="LeadGen Home">
        {content}
      </Link>
    );
  }

  return content;
}
